import React, { useState } from "react";
import useForm from "../useForm";
import { sendEmail } from "../../../actions/userActions";
import { ToastContainer, toast } from "react-toastify";

import "./FormContact.css";
import "react-toastify/dist/ReactToastify.css";

const FormContact: React.FC = () => {
  let sendSuccessful = null;
  const { handleChange, values } = useForm();
  let [isDisabled, setIsDisabled] = useState(false);

  function handleSubmit(event: any) {
    event.preventDefault();
    setIsDisabled(true);

    sendEmail(values);
    toast.info("Sending email...", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return (
    <form autoComplete="off" onSubmit={handleSubmit} noValidate={false}>
      <label htmlFor="name">Name</label>
      <input
        id="name"
        name="name"
        type="text"
        value={values.name}
        onChange={handleChange}
      />
      <label htmlFor="email">Email</label>
      <input
        id="email"
        name="email"
        type="email"
        value={values.email.trim()}
        onChange={handleChange}
        required
      />
      <label htmlFor="message">Message</label>
      <textarea
        id="message"
        name="message"
        value={values.message}
        onChange={handleChange}
        required
      />
      {sendSuccessful === false && <p className="send__fail">Email not sent</p>}
      <button type="submit" className="button_green" disabled={isDisabled}>
        Send message
      </button>
      <ToastContainer
        position="bottom-right"
        // autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </form>
  );
};

export default FormContact;
